export enum GDPRZone {
  EU = 'EU',
  UAE = 'UAE'
}
